import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { showOtherModalsAtom } from '../store';
import { useCurrentUser } from './queries';

type Props = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

/**
 * In this hook, we handle the logic for showing the welcome modal and other modals that
 * possibly show on load on the history page.
 *
 * The Welcome modal takes precedence over other modals.
 *
 * While the welcome modal logic is pending, we leave the showOtherModalsAtom as false.
 *
 * Once the logic is complete, we either set it to true, or leave it as false.
 *
 * Other modals, like the HolidayModal, have hooks that will check
 * the showOtherModalsAtom and only show if it is true.
 */
export const useShowWelcomeModal = ({ setOpen }: Props) => {
  const { user } = useCurrentUser();
  const [, setShowOtherModals] = useAtom(showOtherModalsAtom);

  return useEffect(() => {
    if (
      user!.createTimestamp &&
      user!.createTimestamp > Date.now() - 1000 * 60 * 60 * 24 * 3 // check if user creation timestamp is within the 3 days
    ) {
      const welcomeModalSeen = localStorage.getItem('welcomeModalSeen');

      if (!welcomeModalSeen || welcomeModalSeen === 'false') {
        localStorage.setItem('welcomeModalSeen', 'true');
        setOpen(true);

        return;
      }
    }

    setShowOtherModals(true);
  }, [setOpen, user, setShowOtherModals]);
};
